import { http } from '@/shared/api/http-client'
import { ApiRoutes } from '@/shared/api/routes'
import type { LoginResponse } from '@/shared/types/api-token'

export const authApi = {
  async login(username: string, password: string): Promise<LoginResponse> {
    const { data } = await http.post<LoginResponse>(ApiRoutes.LOGIN, {
      username,
      password,
    })
    return data
  },

  async logout(): Promise<void> {
    try {
      await http.post(ApiRoutes.LOGOUT, {})
    } catch {
      return
    }
  },

  async requestPasswordReset(email: string): Promise<void> {
    await http.post(ApiRoutes.PASSWORD_RESET_REQUEST, { email })
  },

  async validatePasswordResetToken(token: string): Promise<void> {
    await http.post(ApiRoutes.PASSWORD_RESET_VALIDATE, { token })
  },

  async confirmPasswordReset(
    token: string,
    newPassword: string,
  ): Promise<void> {
    await http.post(ApiRoutes.PASSWORD_RESET_CONFIRM, { token, newPassword })
  },

  async requestActivation(email: string): Promise<void> {
    await http.post(ApiRoutes.ACTIVATION_REQUEST, { email })
  },

  async validateActivationToken(token: string): Promise<void> {
    await http.post(ApiRoutes.ACTIVATION_VALIDATE, { token })
  },

  async confirmActivation(token: string, newPassword: string): Promise<void> {
    await http.post(ApiRoutes.ACTIVATION_CONFIRM, { token, newPassword })
  },
}
